import { FetchLocales } from "../../api/Locales";

export const useFetchLocales = async () => {
  const data = await FetchLocales();
  return data;
};
